import { type PropsWithChildren } from 'react';
import { View, type ViewProps } from 'tamagui';

import { getRedactProps } from './redactProps';

export const redactPrivate = (): object => {
    return getRedactProps();
};

export const Private = ({
    children,
    ...viewProps
}: PropsWithChildren & ViewProps) => {
    return (
        <View {...viewProps} {...redactPrivate()}>
            {children}
        </View>
    );
};
